import { LayoutMode } from '../types';

export const SET_PRODUCT_COLLECTION_LAYOUT = 'SET_PRODUCT_COLLECTION_LAYOUT';

export type SetProductCollectionLayoutAction = {
  type: typeof SET_PRODUCT_COLLECTION_LAYOUT;
  layout: LayoutMode;
};

export const setProductCollectionLayout = (
  layout: LayoutMode
): SetProductCollectionLayoutAction => ({
  type: SET_PRODUCT_COLLECTION_LAYOUT,
  layout,
});

export type ProductCollectionAction = SetProductCollectionLayoutAction;
